export default (state = {}, action) => {

    switch (action.type) {

        case 'GETTING_CCB_EVENTS':
            return Object.assign({},state,{
                ui: action.payload.ui
            })
        case 'GET_CCB_EVENTS_SUCCESS':
            const events = (!state.events) ? action.payload.events : [...state.events,...action.payload.events];
            return Object.assign({},state,{
                ui: action.payload.ui,
                events: events
            })
        case 'GET_CCB_EVENTS_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                message: action.payload.message
            })
        default:
            return state
    }
}
